<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs6 sm2 offset-xs6 offset-sm10>
        <v-btn
          color="primary"
          :loading="loadingExportData"
          :disabled="loadingExportData"
          flat
          @click="download()"
        >
          {{ $t('exportInCsv') }}
          <v-icon color="primary" right>file_download</v-icon>
        </v-btn>
      </v-flex>
      <!-- Nombre total de chats -->
      <v-flex xs12 sm6 md4>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $tc('chats', 2, { count: '' }) | cap }}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ nbChats }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- Nombre de messages échangés -->
      <v-flex xs12 sm6 md4>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $tc('messages', 2, { count: '' }) | cap }}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ nbMessages }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- Durée moyenne des chats -->
      <v-flex xs12 sm6 md4>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $t('averageDurationOfOneChat') | cap }}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ averageDurationFormatted }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- NB ECHEC -->
      <v-flex xs12 sm6 md3>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $t('numberFailures') }}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ nbEchec }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- NB TRANSF -->
      <v-flex xs12 sm6 md3>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $t('numTransfers') }}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ nbTransf }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- NB SUCC -->
      <v-flex xs12 sm6 md3>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $t('numSuccesses') }}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ nbSucc }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- NB FAIL -->
      <v-flex xs12 sm6 md3>
        <v-card>
          <v-card-text v-if="loading" class="text-xs-center pt-3">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <v-container v-else>
            <v-layout row wrap>
              <v-flex xs12>
                <div>
                  <div class="subheading text-xs-center">{{ $t('numMisunderstandings')}}</div>
                </div>
              </v-flex>
              <v-flex xs12 class="primary--text display-1 text-xs-center">
                {{ nbFail }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- Graphiques jauges Nb Echec -->
      <v-flex xs12 sm6 md3>
        <v-card class="mb-3" :height="heightOfJauge">
          <v-card-text v-if="loading" class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <highcharts v-else :options="botFailed"></highcharts>
        </v-card>
      </v-flex>
      <!-- Graphiques jauges Nb Transferts -->
      <v-flex xs12 sm6 md3>
        <v-card class="mb-3" :height="heightOfJauge">
          <v-card-text v-if="loading" class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <highcharts v-else :options="botTransfered"></highcharts>
        </v-card>
      </v-flex>
      <!-- Graphiques jauges Nb Succeed -->
      <v-flex xs12 sm6 md3>
        <v-card class="mb-3" :height="heightOfJauge">
          <v-card-text v-if="loading" class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <highcharts v-else :options="botSucceed"></highcharts>
        </v-card>
      </v-flex>      
      <!-- Graphiques jauges bot-en-touche -->
      <v-flex xs12 sm6 md3>
        <v-card class="mb-3" :height="heightOfJauge">
          <v-card-text v-if="loading" class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
          <highcharts v-else :options="botEnTouche"></highcharts>
        </v-card>
      </v-flex>   
    </v-layout>

    <!-- Bouton affcihe/cache les historiques des chats -->
    <span v-if="brideMenu('stats_chatbot_histo') === '1'">
      <v-btn flat @click="getBotChats()" color="accent" v-if="histoready">
        {{ $t('hideChat') }}
        <v-icon  right>visibility_off</v-icon>
      </v-btn>
      <v-btn flat @click="getBotChats()" color="accent" v-else>
        {{ $t('showChat') }}
        <v-icon right>visibility</v-icon>
      </v-btn>
    </span>

    <!-- Historique des bots -->
    <wz-histo-bot
      :params="params"
      :numChatsTotal="String(nbChats)"
      v-if="histoready"
    ></wz-histo-bot>
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import json2csv from 'json2csv'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      loadingExportData: false,
      queryCounter: 0,
      nbSucc: 0,
      nbEchec: 0,
      nbChats: 0,
      nbTransf: 0,
      nbFail: 0,
      chatsPostInvit: 0,
      chatsAverageDuration: 0,
      nbMessages: 0,
      nbConvSucc: 0,
      nbConvEchec: 0,
      nbConvFail: 0,
      nbConvTransf: 0,
      ratioKO: 0,
      ratioOK: 0,
      ratioTransf: 0,
      ratiobotEnTouche: 0,
      histoready: false,
      // options générales pour les jauges
      optionsJauge: {
        chart: {
          type: 'solidgauge',
          height: 180
        },
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        pane: {
          size: '220',
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '95%'],
          background: {
            backgroundColor: '#ddd',
            outerRadius: '100%',
            innerRadius: '90%',
            shape: 'arc',
            borderColor: 'transparent'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          min: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          title: {
            text: ''
          }
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '90%',
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [0]
        }]
      },
      // options pour chacun des graphiques jauges
      botFailed: {
        title: {
          text: _.upperFirst(this.$tc('botFailed', 2, {count: ''}))
        },
        yAxis: {
          stops: [[0, '#009688']], // teal
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-family:'Ubuntu', sans-serif;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      },
      // options pour chacun des graphiques jauges
      botTransfered: {
        title: {
          text: _.upperFirst(this.$tc('botTransfered', 2, {count: ''}))
        },
        yAxis: {
          stops: [[0, '#009688']], // teal
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-family:'Ubuntu', sans-serif;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      },
      // options pour chacun des graphiques jauges
      botSucceed: {
        title: {
          text: _.upperFirst(this.$tc('botSucceed', 2, {count: ''}))
        },
        yAxis: {
          stops: [[0, '#009688']], // teal
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-family:'Ubuntu', sans-serif;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      },
      // options pour chacun des graphiques jauges
      botEnTouche: {
        title: {
          text: _.upperFirst(this.$t('convMisunderstanding'))
        },
        yAxis: {
          stops: [[0, '#009688']], // teal
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-family:'Ubuntu', sans-serif;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      }
    }
  },

  created () {
    // initialisation des options liées aux graphiques
    this.botFailed = _.merge(this.botFailed, this.optionsJauge)
    this.botSucceed = _.merge(this.botSucceed, this.optionsJauge)
    this.botTransfered = _.merge(this.botTransfered, this.optionsJauge)
    this.botEnTouche = _.merge(this.botEnTouche, this.optionsJauge)
    this.getAll()
  },

  methods: {
    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },

    /**
     * lance toutes les requêtes
     */
    getAll () {
      // affichage des loader
      this.loading = true
      this.queryCounter++
      Promise.all([
        this.getBotStats(),
        this.getChatsDuration(),
        this.getNbMessages()
      ])
      .then(() => {
        if (this.queryCounter === 1) {
          this.loading = false
        }
        this.queryCounter--
      })
    },
    /**
     * Récupère le nombre de chats ainsi que d'autres trucs...
     */
    getBotStats () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_bot_stats.php?' + this.params)
        .then(response => {
          this.nbChats = response.data.nbChats

          this.nbSucc = response.data.nbSucc
          this.nbEchec = response.data.nbEchec
          this.nbTransf = response.data.nbTransf
          this.nbFail = response.data.botEnTouche

          this.nbConvSucc = response.data.nbConvSucc
          this.nbConvEchec = response.data.nbConvEchec
          this.nbConvTransf = response.data.nbConvTransf
          this.nbConvFail = response.data.nbConvFail

          // calcul du ratio de chats échoués
          this.ratioKO = (this.nbConvEchec / this.nbChats) * 100
          // calcul du ratio de chats réussis
          this.ratioOK = (this.nbConvSucc / this.nbChats) * 100
          // calcul du ratio de chats transférés
          this.ratioTransf = (this.nbConvTransf / this.nbChats) * 100
          // calcul du ratio de chats botEnTouche
          this.ratiobotEnTouche = (this.nbConvFail / this.nbChats) * 100

          // mise à jour du graphique avec les données récupérées et calculées
          this.botFailed.series[0].data[0] = this.ratioKO
          this.botFailed.yAxis.title.text = this.nbConvEchec + ' chats'

          this.botTransfered.series[0].data[0] = this.ratioTransf
          this.botTransfered.yAxis.title.text = this.nbConvTransf + ' chats'

          this.botSucceed.series[0].data[0] = this.ratioOK
          this.botSucceed.yAxis.title.text = this.nbConvSucc + ' chats'

          this.botEnTouche.series[0].data[0] = this.ratiobotEnTouche
          this.botEnTouche.yAxis.title.text = this.nbConvFail + ' chats'

          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère les durées des chats
     */
    getChatsDuration () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_bot_duration.php?' + this.params)
        .then(response => {
          // mise à jour du graphique avec les données récupérées
          this.chatsAverageDuration = response.data.dureeMoyenne
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le nombre de messages échangés
     */
    getNbMessages () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/bots_nb_messages.php?' + this.params)
        .then(response => {
          // mise à jour des données récupérées
          this.nbMessages = response.data.nbBulles
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },

    download () {
      this.loadingExportData = true
      let csv = null
      const fields = [
        'chats',
        'messages',
        'averageDurationOfOneChat',
        'numberFailures',
        'numTransfers',
        'numSuccesses',
        'numMisunderstandings',
        'botFailed',
        'botTransfered',
        'botSucceed',
        'convMisunderstanding'
      ]
      const fieldNames = [
        this.$tc('chats', 2, { count: '' }),
        this.$tc('messages', 2, { count: '' }),
        this.$t('averageDurationOfOneChat'),
        this.$t('numberFailures'),
        this.$t('numTransfers'),
        this.$t('numSuccesses'),
        this.$t('numMisunderstandings'),
        this.$tc('botFailed', 2, {count: ''}),
        this.$tc('botTransfered', 2, {count: ''}),
        this.$tc('botSucceed', 2, {count: ''}),
        this.$t('convMisunderstanding')
      ]
      const data = {
        chats: this.nbChats,
        messages: this.nbMessages,
        averageDurationOfOneChat: this.averageDurationFormatted,
        numberFailures: this.nbEchec,
        numTransfers: this.nbTransf,
        numSuccesses: this.nbSucc,
        numMisunderstandings: this.nbTransf,
        botFailed: this.ratioKO,
        botTransfered: this.ratioTransf,
        botSucceed: this.ratioOK,
        convMisunderstanding: this.ratiobotEnTouche
      }
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        this.loadingExportData = false
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chats.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
      this.loadingExportData = false
    },

    getBotChats () {
      if (this.histoready) {
        this.histoready = false
      } else {
        this.histoready = true
      }
    }
  },

  computed: {
    ...mapState('_User', ['brides']),
    ...mapGetters('_Stats', ['params']),
    heightOfJauge () {
      return this.optionsJauge.chart.height + 'px'
    },
    averageDurationFormatted () {
      return moment.duration(this.chatsAverageDuration, 'seconds').format('h[h] m[m] s[s]')
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/Chatbot.vue